import { Button } from 'antd';
import styled from 'styled-components';

export const Container = styled(Button)`
  margin-top: 0px;
`;
